import React, {FC} from 'react'
import {CellPropsType} from './cellPropsType'
import {Switch, Tooltip} from '@mdsol/onex-design'
import {useDispatch, useSelector} from 'react-redux'
import {select_databases_databaseEnabled} from 'redux/databases/selectors'
import {AppState} from 'redux/config'
import {toggleDatabaseEnabled} from 'redux/databases/databases.duck'
import {useRouter} from '@uirouter/react'
import {DatabaseMetadata} from 'graphql-api'
import {select_auth_user} from 'redux/auth/selectors'

const Enabled: FC<CellPropsType> = ({cell}) => {
  const dispatch = useDispatch()
  const router = useRouter()

  const {index: rowIndex, original: {databaseId}} = cell.row as {index, original: DatabaseMetadata}
  const enabled = useSelector((state: AppState) => select_databases_databaseEnabled(state, rowIndex))
  const {isAdmin} = useSelector(select_auth_user)
  const handleDbEnableToggle = () => {
    // @ts-ignore
    dispatch(toggleDatabaseEnabled(router, rowIndex, databaseId, !enabled))
  }

  return (
    <Tooltip
      id='toggle-enabled-database-tooltip'
      tooltipChildren={enabled ? 'Disable processing' : 'Enable processing'}
      placement='bottom-end'
    >
      <Switch
        checked={enabled}
        disabled={!isAdmin}
        onChange={handleDbEnableToggle}
        id={`enabled-database-id-${databaseId}`}
        dataTestId='database-enabled-cell'
        className='is-enabled'
      />
    </Tooltip>
  )
}

export default Enabled
